import InputTypesEnum from "../../../Enums/InputTypesEnum";
import IobLineItemSearchParams from "./IobLineItemSearchParams";

export default class TpIobLineItemEvaluatorSearchParams extends IobLineItemSearchParams {

    static fieldsInSearchBox = [
        { fieldName: "IoblineItemId", label: "Line Item ID", className: "col-4", type: InputTypesEnum.Text },
		{ fieldName: "Type", label: "Type", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getSelectValuesForType() },
		{ fieldName: "SelectedTpLocationCountries", label: "Job Country", className: "col-4", type: InputTypesEnum.CountryCodeMultiChoice },
		{ fieldName: "SelectedTpEvaluatorCountries", label: "Evaluator Country", className: "col-4", type: InputTypesEnum.CountryMultiChoice },
		{ fieldName: "SelectedStatuses", label: "Status", className: "col-4", type: InputTypesEnum.MultiChoice, options: IobLineItemSearchParams.getStatusValues() },
		{ fieldName: "ThirdPartyJobId", label: "Third-Party Job ID", className: "col-4", type: InputTypesEnum.Text },
    ];
}